import UpdateTestForm from 'components/form/admin/master/test/UpdateTestForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class UpdateTest extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Test</h4>
                                <UpdateTestForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
